/**************************************************
 * Nombre:       Tarjeta_Variante
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useProductosCarrito} from "../../Modulo_Carrito_Flotante/Funcionamiento/Hooks/useProductosCarrito";
import {adap_item_producto_carrito} from "../Adaptadores/adap_item_producto_carrito";

const Tarjeta_Variante = ({item, producto}) => {
    const {agregarProducto, estaProducto, obtenerProducto} = useProductosCarrito()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            onClick={() => agregarProducto(adap_item_producto_carrito({entidad: producto, variante: item}))}
            sx={{
                border: 1, borderColor: theme.palette.primary.main, p: 1, cursor: 'pointer',
                '&:hover': {
                    backgroundColor: theme.palette.primary.main + 20,
                }
            }}
        >

            <Grid container size={{xs: 8, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 12, fontWeight: 400, color: '#00000080', lineHeight: 1.1}}>
                    {producto?.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 4, sm: 12, md: 5}} sx={{justifyContent: 'flex-end'}}>
                <Typography sx={{
                    fontSize: 12,
                    fontWeight: 500,
                    color: '#fff',
                    backgroundColor: theme.palette.primary.main,
                    px: obtenerProducto((adap_item_producto_carrito({
                        entidad: producto,
                        variante: item
                    }).id)) ? 1 : 0,
                    py: 0.5,
                    mt: -1,
                    mr: -1
                }}>
                    {obtenerProducto((adap_item_producto_carrito({
                        entidad: producto,
                        variante: item
                    }).id)) ? obtenerProducto((adap_item_producto_carrito({
                        entidad: producto,
                        variante: item
                    }).id)).cantidad + ' Agregado' : ''}
                </Typography>
            </Grid>

            <Grid container size={{xs: 6, sm: 12, md: 6}}
                  sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontWeight: 600, lineHeight: 1.1}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 6, sm: 12, md: 6}}
                  sx={{justifyContent: 'flex-end', mt: 0}}>
                <Typography sx={{
                    fontWeight: 700,
                    color: theme.palette.primary.main
                }}>{formatoMoneda(item.valor) + ' MX'}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Variante